
import Setting from '~/components/Settings/Setting'
import Button from '@/components/UntitledUI/Button.vue'

export default {
    name: 'Redeem',
    components: { Button, Setting },
    data () {
        return {
            form: new this.$vForm({
                coupon: ''
            })
        }
    },
    methods: {
        send () {
            this.form.post('/v1/Coupons/Use')
                .then(async (res) => {
                    await this.$auth.fetchUser()

                    this.$refs.settings.alert({
                        type: 'success',
                        body: this.$t('settings coupons success')
                    })
                })
                .catch((err) => {
                    this.$refs.settings.alert({
                        type: 'danger',
                        body: this.$t('general error')
                    })
                })
        }
    }
}
